/**
 * Modules
 */

var isFunction = require('@f/is-function')

/**
 * Expose isObject
 */

module.exports = isObject

/**
 * Constants
 */

var objString = toString(Object)

/**
 * Check for plain object.
 *
 * @param {Mixed} val
 * @return {Boolean}
 * @api private
 */

function isObject (val) {
  return !!val && (val.constructor === Object || isObjectString(val.constructor))
}

function isObjectString (val) {
  return !!val && isFunction(val) && toString(val) === objString
}

function toString (val) {
  return Function.prototype.toString.call(val)
}



//////////////////
// WEBPACK FOOTER
// ./~/@f/is-object/lib/index.js
// module id = ./node_modules/@f/is-object/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons